import { API } from '../helpers/fetcher'

export const paypalAuthentication = async params =>
  API.post('v1/transaction/paypal/authenticate', params)
